// TODO: This should be moved to the feature library as a view model and not a DTO model.
export class Action {
  name: string;
  action: (data: any) => {};
  disabled: boolean;
  color: string;
}
